(function() {
    'use strict';

    angular
        .module('app')
        .directive('sideMenu', sideMenu);

    sideMenu.$inject = ['$timeout'];
    
    function sideMenu ($timeout) {
        // Usage:
        //     <sideMenu></sideMenu>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                menuActive: "=?",
                sidebarOpened: "=?"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            if (element.next().hasClass("menu-subitems")) {
                scope.$watch(function () {
                    return scope.menuActive;
                }, function (value) {
                    if (value) {
                        element.addClass("menu-active");
                        $(element.next()).slideDown(500, function () {

                        });
                    }
                    else {
                        element.removeClass("menu-active");
                        $(element.next()).slideUp(500, function () {

                        });
                    }
                });
            }

            var title = "";
            scope.$watch(function () {
                return scope.sidebarOpened;
            }, function (value) {
                if (value) {
                    var children = element.children();
                    var iconEl = angular.element(children[0]);
                    var titleEl = angular.element(children[1]);
                    if (element.next().hasClass("menu-subitems")) {
                        var angleEl = angular.element(children[2]);
                        angleEl.css("display", 'inline');
                        var subItems = element.next();
                        subItems.removeClass('menu-subitems-hover');
                        subItems.unbind('click');
                        if (subItems.hasClass('temp')) {
                            subItems.remove();
                        }
                        else {
                            angular.forEach(subItems.children(), function (item, value) {
                                if (angular.element(item).hasClass('subitem-header')) {
                                    angular.element(item).remove();
                                }
                            })
                        }
                    }
                    element.removeClass('icon-hover');
                    titleEl.css("display", 'inline');                    
                }
                else {
                    element.removeClass('menu-active');
                    element.next().css('display', '');
                    $(element.next()).slideUp();
                    var children = element.children();
                    var iconEl = angular.element(children[0]);
                    var titleEl = angular.element(children[1]);
                    if (!element.next().hasClass("menu-subitems")) {
                        var item = angular.element("<div class='menu-subitems temp'><div>");
                        element.after(item);
                    }

                    var angleEl = angular.element(children[2]);
                    angleEl.css("display", 'none');
                    var subItems = element.next();
                    subItems.addClass('menu-subitems-hover');
                    var heading = angular.element('<div class="subitem-header">' + titleEl.text() + '</div>');
                    subItems.prepend(heading);
                    subItems.css('display', '');
                    subItems.bind('click', function () {
                        subItems.css('display', 'none');
                        $timeout(function () {
                            subItems.css('display', '');
                        }, 100);
                    });

                    element.addClass('icon-hover');
                    title = titleEl.contents();
                    titleEl.css("display", 'none');

                }
            });
        }

        
    }

})();